export default __webpack_public_path__ + "static/media/Arhive_light.24a927b4.svg";